module.exports = __webpack_public_path__ + "static/GWPAC-gift-group2-800x500-ce2dcddf978bdfed07e62fb0d73c2e71.jpg";